export const foreclosures = [
  {
    value: "None",
    name: "None",
  },
  {
    value: "36+ Months",
    name: "36+ Months",
  },
  {
    value: "24+ Months",
    name: "24+ Months",
  },
  {
    value: "12+ Months",
    name: "12+ Months",
  },
  {
    value: "< 12 Months",
    name: "< 12 Months",
  },
];



// WEBPACK FOOTER //
// ./src/constants/foreclosures.js